import React from 'react';
import GradientButton from '@/components/ui/GradientButton';
import { CloudDownload, Trash2, Loader2 } from 'lucide-react';
import { PerplexityContent } from '../types/PerplexityContent';
import { useResearchPDF } from '@/hooks/pdf';

interface PerplexityActionButtonsProps {
  content: PerplexityContent;
  onDelete?: (content: PerplexityContent) => Promise<void>;
  onDownload?: (content: PerplexityContent) => void;
  checkOwnership?: (content: PerplexityContent) => Promise<boolean>;
}

export const PerplexityActionButtons: React.FC<PerplexityActionButtonsProps> = ({
  content,
  onDelete,
  onDownload,
  checkOwnership
}) => {
  const { generatePDF, isGenerating } = useResearchPDF();

  const handleDownload = () => {
    if (onDownload) {
      onDownload(content);
    } else {
      // Generate PDF instead of markdown
      generatePDF(content);
    }
  };

  const handleDelete = async () => {
    if (onDelete) {
      await onDelete(content);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      {/* Download Button */}
      {(onDownload || true) && (
        <GradientButton
          variant="blue"
          icon={isGenerating ? <Loader2 className="h-4 w-4 animate-spin" /> : <CloudDownload className="h-4 w-4" />}
          onClick={handleDownload}
          disabled={isGenerating}
          testId="download-research-button"
          fullWidth
        >
          {isGenerating ? 'Generating PDF...' : 'Download PDF'}
        </GradientButton>
      )}

      {/* Delete Button */}
      {onDelete && (
        <GradientButton
          variant="red"
          icon={<Trash2 className="h-4 w-4" />}
          onClick={handleDelete}
          testId="delete-research-button"
          fullWidth
        >
          Delete
        </GradientButton>
      )}
    </div>
  );
}; 